import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LogsDataSource, AlertHttpService } from '../../../../../app/core/alerts';
import { MatPaginator, MatSort } from '@angular/material';
import { Cache } from 'aws-amplify';
import { tap } from 'rxjs/operators';
import { merge } from 'rxjs';
import { MixpanelService } from '../../../../services/mixpanel.service'; // Import MixpanelService

@Component({
  selector: 'kt-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit, AfterViewInit {

	displayedColumns = ['time_stamp', 'log_type', 'log_code'];

	dataSource: LogsDataSource;

	qParams: any;

	logCodes;

	@Input() title: string;

	@Input() logType: string;

	@Input() showFilter: boolean;

	@Output() logCntEvent = new EventEmitter<number>();

	searchForm: FormGroup;

	errOpt: any[] = [];

	wrnOpt: any[] = [];

	opts: any[] = [];

	selectedMachine = Cache.getItem('selected_machine');

	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	@ViewChild(MatSort, {static: false}) sort: MatSort;

	constructor(private http: AlertHttpService, private mixpanel: MixpanelService) { } // Inject MixpanelService

  ngOnInit() {

	console.log(this.logType);

	if (this.title === undefined) {
		this.title = 'Logs';
	}

	if (this.showFilter === undefined) {
		this.showFilter = true;
	}

	this.dataSource = new LogsDataSource(this.http);
	this.searchForm = new FormGroup({
		logType: new FormControl('all', [Validators.required]),
		logDesc: new FormControl(null),
		startDate: new FormControl(new Date(), [Validators.required]),
		endDate: new FormControl(new Date(), [Validators.required])
	});

	if (this.logType !== undefined) {
		this.searchForm.patchValue({
			logType: this.logType
		});
	}

	this.getLogCodes();
	this.qParams = {
		noPerPg: this.paginator.pageSize || 10,
		pgNo: this.paginator.pageIndex || 0,
		machine_id: this.selectedMachine.machine_id,
		sortKey: 'time_stamp',
		sortVal: 'desc',
		optFilterKey: 'log_type',
		optFilterVal: this.logType || `'err','wrn'`,
		txtFilterKey: '',
		txtFilterVal: null,
		startDate: this.dateFormatUTC(this.searchForm.get('startDate').value, 'start'),
		endDate: ''
	};
		this.mixpanel.track(this.mixpanel.PAGE_VIEW, {
			machineId: this.selectedMachine.machine_id,
			machineName: this.selectedMachine.machine_name,
			machineSerialNo: this.selectedMachine.serial_no
		});
	}

  ngAfterViewInit() {
	this.dataSource.counter$
	.pipe(
		tap((count) => {
			this.paginator.length = count;
			if (this.showFilter === false) {
				this.logCntEvent.emit(count);
			}
		})
	)
	.subscribe();

	this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

	merge(this.paginator.page, this.sort.sortChange).pipe(
		tap(() => {
			console.log(this.paginator.pageIndex);
			this.loadLogs();
		})
	).subscribe();

  }

  dateFormatUTC(date: Date, period: string) {
	let dateStr =
	`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${(date.getDate()).toString().padStart(2, '0')} `;
	if (period === 'start') {
		dateStr += '00:00:00';
	} else {
		dateStr += '23:59:59';
	}
	return new Date(dateStr.replace(/-/g, '/')).toISOString();
}

typeChanged() {
	console.log(this.searchForm.get('logType').value);
	this.opts = [];
	const typeSel = this.searchForm.get('logType').value;
	if (typeSel === 'all') {
		this.opts = this.errOpt.concat(this.wrnOpt);
	} else if (typeSel === 'err') {
		this.opts = this.errOpt;
	} else if (typeSel === 'wrn') {
		this.opts = this.wrnOpt;
	}
}

  getLogCodes() {
	  this.http.getMacLogCodes()
	  .subscribe(logCodes => {
		this.logCodes = logCodes.processed;
		console.log(logCodes);
		// this.segregateOptions(logCodes.raw);
		this.loadLogs();
	  });
  }

  segregateOptions(opts: any) {
	for (let row of opts) {
		if (row.log_code.startsWith('e0')) {
			this.errOpt.push(row);
		} else if (row.log_code.startsWith('w0')) {
			this.wrnOpt.push(row);
		}
	}
	this.opts = this.errOpt.concat(this.wrnOpt);

  }

  parseLogType(log: any) {
	  if (log.log_code.startsWith('e0')) {
		return 'Error';
	  } else if (log.log_code.startsWith('w0')) {
		return 'Warning';
	  } else {
		return 'NA';
	  }
  }

  parseLogCodes(codeObj) {
	if (codeObj.occOrRes === 0 || codeObj.occOrRes === 1) {
		const content = this.logCodes[codeObj.occOrRes];
		if (content.hasOwnProperty([codeObj.log_code])) {
		return content[codeObj.log_code];
		} else {
		return codeObj.log_code;
		}
	} else {
		return codeObj.log_code;
	}
  }

  loadLogs() {
	console.log('Load logs');

	this.qParams = {
		noPerPg: this.paginator.pageSize || 10,
		pgNo: this.paginator.pageIndex || 0,
		machine_id: this.selectedMachine.machine_id,
		sortKey: this.sort.active,
		sortVal: this.sort.direction,
		optFilterKey: 'log_type',
		optFilterVal: this.searchForm.get('logType').value,
		txtFilterKey: 'log_code',
		txtFilterVal: this.searchForm.get('logDesc').value,
		startDate: this.dateFormatUTC(this.searchForm.get('startDate').value, 'start'),
		endDate: this.dateFormatUTC(this.searchForm.get('endDate').value, 'end')
	};
	if (this.searchForm.get('logType').value === 'all') {
		this.qParams.optFilterVal = `'err','wrn'`;
	}
	console.log(this.qParams);
	this.dataSource.loadLogsList(this.qParams);
  }

  onSubmited() {
	this.paginator.pageIndex = 0;
	// console.log( '\'' + (this.searchForm.get('logDesc').value).join('\',\'') + '\'');
	this.qParams = {
		noPerPg: this.paginator.pageSize || 10,
		pgNo: this.paginator.pageIndex || 0,
		machine_id: this.selectedMachine.machine_id,
		sortKey: this.sort.active,
		sortVal: this.sort.direction,
		optFilterKey: 'log_type',
		optFilterVal: this.searchForm.get('logType').value,
		txtFilterKey: 'log_code',
		txtFilterVal: this.searchForm.get('logDesc').value,
		startDate: this.dateFormatUTC(this.searchForm.get('startDate').value, 'start'),
		endDate: this.dateFormatUTC(this.searchForm.get('endDate').value, 'end')
	};
	if (this.searchForm.get('logType').value === 'all') {
		this.qParams.optFilterVal = `'err','wrn'`;
	}
	console.log(this.qParams);
	this.dataSource.loadLogsList(this.qParams);
  }

}
